module.exports = __webpack_public_path__ + "img/f0ffdd7.png";